import { dataService } from "../services/data.service";
import {
  CREATE_USER,
  UPDATE_USER,
  SET_USER,
  DELETE_USER,
  RESET_USER_STATE,
  SIGNOUT
} from "./mutation-types";

const state = () => ({
  //users: [],
  user: {}
});
export const getDefaultState = () => ({
  user: {}
});

const mutations = {
  [CREATE_USER](state, user) {
    state.user = Object.assign({}, state.user, user);
    //state.users.push(user);
  },
  [UPDATE_USER](state, user) {
    state.user = Object.assign({}, state.user, user);
    // if (state.users != null) {
    //   const index = state.users.findIndex(x => x.Id === user.Id);
    //   state.users.splice(index, 1, user);
    //   state.users = [...state.users];
    // }
  },
  [SET_USER](state, user) {
    state.user = Object.assign({}, state.user, user);
  },
  [DELETE_USER](state, user) {
    //state.users.push(user);
    state.user = Object.assign({}, state.user, user);
  },
  [RESET_USER_STATE](state) {
    Object.assign(state, getDefaultState());
  },
  [SIGNOUT](state) {
    state.status = { signedin: false };
    state.user = null;
  }
};

const actions = {
  async createUser({ commit, dispatch }, { user, regStatus }) {
    try {
      const createdUser = await dataService.register(user);

      regStatus == 1
        ? commit(CREATE_USER, createdUser)
        : commit(UPDATE_USER, createdUser);
    } catch (error) {
      dispatch("alert/error", dataService.errorResponseHandler(error), {
        root: true
      });
    }
  },
  async updateUser({ commit, dispatch },{ user,section}) {
    try {
      const updatedUser = await dataService.updateUser(user,section);
      commit(UPDATE_USER, updatedUser);
      commit(`account/${SET_USER}`, { FirstName: updatedUser.FirstName });
      dispatch("alert/success", "Account has been updated", {
        root: true
      });
    } catch (error) {
      dispatch("alert/error", dataService.errorResponseHandler(error), {
        root: true
      });
    }
  },
  async logoutAndDeleteUser({ commit, dispatch }) {
    try {
      await dataService.logoutAndDeleteUser();
      //commit(DELETE_USER, { user: null });
      await commit(SIGNOUT);
      //dispatch("account/signout",'', { root: true });
    } catch (error) {
      dispatch("alert/error", dataService.errorResponseHandler(error), {
        root: true
      });
    }
  },
  async verifyAccount({ commit, dispatch }, { key }) {
    try {
      const result = await dataService.verifyAccount(key);
      commit(SET_USER, result);
      return true;
    } catch (error) {
      dispatch("alert/error", dataService.errorResponseHandler(error), {
        root: true
      }).then(() => {
        return false;
      });
      return false;
    }
  },
  async setUser({ commit, dispatch }, user) {
    try {
      commit(SET_USER, user);
    } catch (error) {
      dispatch("alert/error", error, {
        root: true
      });
    }
  },
  async resetUser({ commit }) {
    commit(RESET_USER_STATE);
  }
};

//const modules = {};

const getters = {
  getUserById: state => id => state.users.find(x => x.Id == id),
  getFirstName: state => state.user.FirstName
};

export const users = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
